var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.item.hidden)?_c('li',[_c('router-link',{attrs:{"to":_vm.resolve()}},[_c('el-menu-item',{attrs:{"index":_vm.index}},[_c('i',{class:_vm.icon}),_c('span',[_vm._v(_vm._s(_vm.item.children[0].meta.title))])])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }